import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Capture from './pages/Capture';
import Viewer from './pages/Viewer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/capture/:sessionId" element={<Capture />} />
          <Route path="/viewer" element={<Viewer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
